
import { DomElement } from "../../../../../library/ts/html/dom/DomElement";
import { ReminderModeIcon } from "./reminder-mode-icon";

export abstract class ReminderModeElement extends DomElement<HTMLElement>
{ 
  _modeIcon:ReminderModeIcon;
  get modeIcon(){ return this._modeIcon; }
}